import React, {FC, ReactNode} from 'react';
import {useTheme} from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerContent} from '../../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerContentTitle} from '../../../../../libs/shared/ui/src/components/banners/bannerContentTitle';
import {BannerIcon} from '../../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';

/*
 * Props.
 */

interface MacrosErrorBannerProps {
  name: string;
  errorMessage: ReactNode;
  onDismissClick: () => void;
}

/*
 * Component.
 */

export const MacrosErrorBanner: FC<MacrosErrorBannerProps> = ({name, onDismissClick, errorMessage}) => {
  const theme = useTheme();
  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      priority={BannerPrioritiesEnum.ERROR}
      color={theme.palette.red.shade40}
    >
      <BannerCloseAction onClick={onDismissClick} />
      <BannerIcon iconName="warningFilledSmall" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="macros-error-banner-text">{name} failed</Trans>
        </BannerContentTitle>
        {errorMessage}
      </BannerContent>
    </Banner>
  );
};
